export default "__VITE_ASSET__CFbQCQ$e__"